export async function loadFlightPreviews<T>(
  flightIds: string[],
  load: (flightId: string) => Promise<T>,
  onProgress: (completed: number) => void,
  signal?: AbortSignal
): Promise<T[]> {
  const results: T[] = [];
  let index = 0;
  let completed = 0;
  let failure: unknown;
  let failed = false;
  let lastStart = -Infinity;
  let startGate = Promise.resolve();
  const waitForStart = async () => {
    const delay = Math.max(0, 275 - (Date.now() - lastStart));
    if (delay) {
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
    lastStart = Date.now();
  };

  // Serialize request starts while allowing up to four responses in flight.
  const worker = async () => {
    while (index < flightIds.length && !failed && !signal?.aborted) {
      const current = index++;
      const gate = startGate.then(waitForStart);
      startGate = gate;
      await gate;
      if (failed || signal?.aborted) {
        return;
      }
      try {
        results[current] = await load(flightIds[current]);
        if (!signal?.aborted) {
          onProgress(++completed);
        }
      } catch (error) {
        failed = true;
        failure = error;
      }
    }
  };
  await Promise.all(Array.from({ length: Math.min(4, flightIds.length) }, worker));
  if (failed) {
    throw failure;
  }
  return results;
}
